
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.918","height":"23.903"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"aaa1","y1":".68","x2":"1","y2":".68","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#8930fd"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#49ccf9"}})]),_c('linearGradient',{attrs:{"id":"bbb1","y1":".68","x2":"1","y2":".68","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ff02f0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ffc800"}})])]),_c('path',{attrs:{"d":"M2.638 668.009l3.676-2.816c1.953 2.549 4.028 3.723 6.337 3.723s4.313-1.161 6.178-3.689l3.728 2.748c-2.691 3.646-6.034 5.573-9.906 5.573s-7.235-1.914-10.012-5.539z","transform":"translate(-2.638 -649.645)","fill":"url(#aaa1)"}}),_c('path',{attrs:{"d":"M30.733 7.18l-6.542 5.638-3.025-3.507 9.58-8.256 9.5 8.262-3.038 3.495z","transform":"translate(-20.733 -1.055)","fill":"url(#bbb1)"}})])
          )
        }
      }
    